<template lang="pug">
  #Akkuk.app.urlap.roll(:class="{loading: busy}")
    vue-headful(title="Akkuk - Forex kft.")
    .kereses: .kereses-content
      .block: .page-title Akkumulátor kereső
      .block: form(@submit.prevent="kereses()")
        div.label Gyártmány, modell, évjárat:
        .field.is-grouped
          .control.is-expanded: input.input(v-model='query' :readonly='busy' ref='query')
          .control: button.button.is-primary(type="submit", :class='{"is-loading": busy}', :disabled="!queryValid") Keresés

    .lista.roll-main(:class="{off: !hasResult}"): .content
      .uzenet(v-show='busy') Keresés folyamatban...
      .uzenet(v-show='!busy && !results.length') Nincs találat
      table.table.is-striped(v-show="results.length")
        thead
          th Gyártmány
          th Modell
          th Típus
          th Gyártási Év
          th Üzemanyag
          th Akku típusok
        tbody
          tr(v-for='result in results', :key="result.Jarmu.Id")
            td {{ result.Jarmu.Gyártmány }}
            td {{ result.Jarmu.Modell }}
            td {{ result.Jarmu.Típus }}
            td {{ result.Jarmu.GyártásiÉv }}
            td {{ result.Jarmu.ÜzemanyagTípus }}
            td
              b: a(v-for='accu in result.Akkuk' :href='accu.Url', target="_blank") {{ accu.Típus }} &nbsp;
</template>

<script>

  import {AkkuService} from "./AkkuService.js";

  export default {
    data: () => ({
      query: '',
      busy: false,
      hasResult: false,
      results: [],
      timer: null,
    }),
    name: "Akkuk",
    created() {
      this.service = new AkkuService();
      this.$nextTick(function() { this.$refs.query.focus(); });
    },
    computed: {
      queryValid() {
        console.log(this.query);
        return this.query && this.query.trim().length > 2
      }
    },

    methods:
        {
          async kereses()
          {
            this.results = [];
            this.busy = true;
            this.results = await this.service.SendQuery(this.query);
            this.busy = false;
            this.hasResult = true;


          }
        },
  }

</script>

<style lang='sass'>
  $primary: #1846ec
  $link-hover: #E92539
  @import "../app/main.sass"

  .urlap
    padding: 0 1rem
    max-width: 80rem

  #Akkuk

    .block
      margin-bottom: 1rem
    .page-title
      background: #ED1C24
    .logo
      flex: 1
    #logo
      height: 100%

    .kereses
      flex: 1 0 auto
      display: flex
      align-items: center

      transition: all .5s
      .kereses-content
        width: 100%

      .label
        color: #fafafa
      .input, .button
        font-size: 1.2rem
        height: 3rem
      .input
        border-radius: 1px
        border-color: #fff
        box-shadow: none
        &:focus
          box-shadow: 0 0 0 2px $primary

    .lista
      flex: 0 1 auto
      transition: all .6s ease
      background: #fff
      height: 100%
      .table
        transition: all .3s ease
        background: none

    .lista.off
      height: 0

    &.loading
      .table
        opacity: 0

    .uzenet
      display: flex
      position: absolute
      left: 0
      right: 0
      top: 0
      bottom: 0
      align-items: center
      justify-content: center
      font-weight: bold

  .error
    margin: 1rem 0

  table th, td
    padding-right: 10px
</style>
